import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { LoginType } from '../types';

export const useLogClickSocialAccount = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (type: LoginType) => {
      logAnalyticsEvent({
        name: 'CLICK_SOCIAL_ACCOUNT',
        channel: ['firebase', 'amplitude', 'ablylog'],
        analytics: {
          SCREEN: 'INTRO_SIGN_UP',
          ACCOUNT_TYPE: type.toUpperCase(),
        },
      });
    },
    [logAnalyticsEvent],
  );
};
